import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { styles } from '../../molecules/Input/Input.styles';

export const StyledDateRange = styled(DatePicker)`
  ${styles}
  padding-left: ${({ prefix }) => prefix && '1.5rem'};
  padding-right: ${({ $suffix }) => {
    if ($suffix) return '1.5rem';
    return '1.5rem';
  }};
`;

export const ButtonHolder = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 12px;
`;
